import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';
import AdminShell from './components/AdminShell';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MembersPage from './pages/MembersPage';
import AddMemberForm from './components/AddMemberForm';
import AddEventPage from './pages/AddEventPage';
import EventsPage from './pages/EventsPage';
import AddCouponPage from './pages/AddCouponPage';
import CouponsPage from './pages/CouponsPage';
import SendNotificationPage from './pages/SendNotificationPage';
import SendPromoPopupPage from './pages/SendPromoPopupPage';
import NotificationsHistoryPage from './pages/NotificationsHistoryPage';
import LogsPage from './pages/LogsPage';
import AppVersionPage from './pages/AppVersionPage';
import MembershipConfigPage from './pages/MembershipConfigPage';
import OtpConfigPage from './pages/OtpConfigPage';
import SignupPage from './pages/SignupPage';
import RenewPage from './pages/RenewPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import PendingApplicationsPage from './pages/PendingApplicationsPage';
import UpgradePage from './pages/UpgradePage';
import { ConfirmProvider } from './components/ConfirmDialog';

export default function App() {
  return (
    <ConfirmProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* The :tier segment is validated inside SignupPage; anything
              else falls through to the picker. */}
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signup/:tier" element={<SignupPage />} />
          <Route path="/renew" element={<RenewPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/upgrade" element={<UpgradePage />} />

          <Route element={<AuthGuard />}>
            <Route element={<AdminShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/members" element={<MembersPage />} />
              <Route path="/members/add" element={<AddMemberForm />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/add" element={<AddEventPage />} />
              <Route path="/coupons" element={<CouponsPage />} />
              <Route path="/coupons/add" element={<AddCouponPage />} />
              <Route path="/notifications/send" element={<SendNotificationPage />} />
              <Route path="/promos/send" element={<SendPromoPopupPage />} />
              <Route path="/notifications/history" element={<NotificationsHistoryPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/app-version" element={<AppVersionPage />} />
              <Route path="/membership/config" element={<MembershipConfigPage />} />
              <Route path="/otp/config" element={<OtpConfigPage />} />
              <Route path="/membership/pending" element={<PendingApplicationsPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfirmProvider>
  );
}
